const CONTACT_EMAIL = "distribution@doblerrecords.com";
const LAST_UPDATE = "10 de agosto de 2026";

export const LEGAL_CONTENT = {
  terminos: {
    title: "Términos y Condiciones de Servicio",
    updated: LAST_UPDATE,
    intro:
      "Los presentes Términos y Condiciones de Servicio (los \"Términos\") regulan el uso de la plataforma de distribución digital de música \"Doble R Records Distribution\" (\"Doble R Records\", \"la Distribuidora\", \"nosotros\") operada a través de doblerrecords.com y del portal de gestión distro.doblerrecords.com. Al registrarse, aceptar estos Términos o utilizar cualquiera de nuestros servicios, el usuario (\"Artista\", \"Label\", \"Representante\" o \"Usuario\") declara haber leído, comprendido y aceptado íntegramente su contenido.",
    sections: [
      {
        heading: "1. Aceptación de los Términos",
        body: [
          "El acceso y uso del portal de distribución implica la aceptación plena y sin reservas de estos Términos. Si el Usuario no está de acuerdo con alguna disposición aquí contenida, deberá abstenerse de utilizar los servicios de Doble R Records.",
          "El registro solo podrá ser realizado por personas mayores de edad con capacidad legal para contratar, o por personas jurídicas debidamente representadas (labels, sellos discográficos, agencias de management).",
        ],
      },
      {
        heading: "2. Modelo de Negocio y Comisiones",
        body: [
          "Doble R Records opera bajo un modelo de licencia de distribución no exclusiva. Por cada lanzamiento distribuido a través de la plataforma, la Distribuidora retendrá una comisión administrativa del diez por ciento (10%) sobre el total de los ingresos brutos generados por regalías, mientras que el noventa por ciento (90%) restante del fondo asignado corresponderá íntegramente al Artista o Label titular del contenido.",
          "El reparto del 90% del fondo entre colaboradores (splits) es responsabilidad exclusiva del Usuario, quien deberá declarar con exactitud los porcentajes correspondientes a cada parte al momento de la carga del lanzamiento.",
          "Las comisiones aquí descritas podrán ser modificadas únicamente mediante notificación previa a los Usuarios activos, sin afectar retroactivamente los lanzamientos ya liquidados.",
        ],
      },
      {
        heading: "3. Alcance del Servicio",
        body: [
          "Doble R Records prestará servicios de entrega y distribución de contenido musical a más de cuatrocientas cincuenta (450) plataformas digitales, tiendas y servicios de streaming a nivel mundial, incluyendo de forma no limitativa Spotify, Apple Music, YouTube Music, Amazon Music, Deezer, Tidal, TikTok, SoundCloud, Pandora, Shazam y otras plataformas asociadas.",
          "Adicionalmente, la Distribuidora ofrece distribución y entrega de videos musicales oficiales mediante tecnología VEVO, sujeto al cumplimiento de los requisitos técnicos y de calidad exigidos por dicha tecnología.",
          "La disponibilidad efectiva de cada lanzamiento en una plataforma específica dependerá de las políticas internas, acuerdos comerciales y restricciones territoriales propias de cada tienda digital, las cuales están fuera del control directo de Doble R Records.",
        ],
      },
      {
        heading: "4. Tiempos de Entrega",
        body: [
          "El procesamiento estándar de lanzamientos aprobados se realiza en un plazo de veinticuatro (24) a cuarenta y ocho (48) horas hábiles, contadas a partir de la aprobación final por parte del equipo de revisión de Doble R Records.",
          "Dicho plazo está sujeto a la correcta entrega de metadata, archivos de audio y portada conforme a los estándares exigidos, así como a los tiempos de indexación e ingesta propios de cada plataforma digital receptora, los cuales pueden variar y no son garantizados por la Distribuidora.",
        ],
      },
      {
        heading: "5. Obligaciones del Usuario",
        body: [
          "El Usuario se obliga a proporcionar información veraz, completa y actualizada en su registro y en cada lanzamiento cargado a la plataforma.",
          "El Usuario declara y garantiza ser el titular legítimo de los derechos de autor y derechos conexos sobre las grabaciones sonoras (masters) y las composiciones musicales entregadas, o contar con las licencias correspondientes que le autoricen su distribución digital.",
          "El Usuario deberá cumplir con los estándares técnicos de calidad exigidos por las plataformas digitales, incluyendo: portadas en formato JPG con resolución mínima de 3000x3000 píxeles, sin logotipos de plataformas ni información de contacto, y archivos de audio en alta calidad WAV o FLAC.",
          "El incumplimiento de cualquiera de estas obligaciones podrá resultar en el rechazo del lanzamiento, la suspensión de la cuenta o la terminación del servicio, sin perjuicio de las acciones legales que correspondan.",
        ],
      },
      {
        heading: "6. Cancelación y Retiro de Catálogo (Takedowns)",
        body: [
          "El Usuario podrá solicitar el retiro total o parcial de su catálogo de las plataformas digitales en cualquier momento, a través del panel privado o mediante solicitud formal al correo de contacto.",
          "El procesamiento de una solicitud de retiro (takedown) puede tardar entre siete (7) y treinta (30) días hábiles, dependiendo de los tiempos de procesamiento propios de cada plataforma digital, los cuales escapan al control de Doble R Records.",
          "Los retiros anticipados de catálogo previamente distribuido podrán estar sujetos a costos administrativos, los cuales serán informados previamente al Usuario antes de confirmar la solicitud.",
        ],
      },
      {
        heading: "7. Limitación de Responsabilidad",
        body: [
          "Doble R Records no será responsable por retrasos, rechazos o remociones de contenido derivados de decisiones unilaterales de las plataformas digitales, ni por pérdidas de ingresos ocasionadas por causas ajenas a su control operativo.",
          "La Distribuidora tampoco será responsable por disputas de titularidad de derechos entre colaboradores, productores, compositores o terceros relacionados con un mismo lanzamiento, siendo dichas disputas responsabilidad exclusiva del Usuario que cargó el contenido.",
        ],
      },
      {
        heading: "8. Modificaciones a los Términos",
        body: [
          "Doble R Records se reserva el derecho de modificar estos Términos en cualquier momento. Las modificaciones serán notificadas a través del portal oficial o por correo electrónico, y entrarán en vigor a partir de su publicación.",
        ],
      },
      {
        heading: "9. Legislación Aplicable",
        body: [
          "Estos Términos se rigen e interpretan de conformidad con la legislación aplicable en materia de propiedad intelectual y comercio digital, sin perjuicio de las normas de protección al consumidor que resulten aplicables en la jurisdicción del Usuario.",
        ],
      },
      {
        heading: "10. Contacto",
        body: [`Para consultas relacionadas con estos Términos y Condiciones, el Usuario puede escribir a ${CONTACT_EMAIL}.`],
      },
    ],
  },
  privacidad: {
    title: "Política de Privacidad",
    updated: LAST_UPDATE,
    intro:
      "En Doble R Records Distribution valoramos la confianza de nuestros Artistas, Labels y Representantes. Esta Política de Privacidad describe de forma clara y minimalista qué información recopilamos, con qué finalidad la utilizamos y qué medidas de seguridad implementamos para protegerla.",
    sections: [
      {
        heading: "1. Responsable del Tratamiento",
        body: [
          "Doble R Records Distribution es responsable del tratamiento de los datos personales recopilados a través de este sitio web y del portal de gestión distro.doblerrecords.com."],
      },
      {
        heading: "2. Datos que Recopilamos",
        body: [
          "Este sitio web opera bajo una arquitectura estática (Jamstack) que no almacena datos en bases de datos expuestas. Los únicos datos recopilados a través del formulario de registro simplificado son: nombre completo, correo electrónico, nombre de artista o label, y tipo de cuenta solicitada (Artista, Label o Representante/Manager).",
          "Datos adicionales como información de catálogo, splits, metadata de lanzamientos y datos financieros para el pago de regalías son gestionados exclusivamente a través del portal oficial distro.doblerrecords.com, bajo sus propios protocolos de seguridad.",
        ],
      },
      {
        heading: "3. Finalidad del Tratamiento",
        body: [
          "Los datos recopilados en el formulario de registro se utilizan únicamente para procesar la solicitud de creación de cuenta y dirigir al Usuario al portal oficial de distribución, donde deberá completar su registro de forma segura.",
        ],
      },
      {
        heading: "4. Datos Financieros y Regalías",
        body: [
          "Toda la información financiera necesaria para la dispersión de regalías (cuentas bancarias, métodos de pago) es gestionada de forma segura y encriptada exclusivamente dentro del portal distro.doblerrecords.com, con acceso restringido y segmentado. Esta landing page no solicita ni almacena datos bancarios en ningún momento.",
        ],
      },
      {
        heading: "5. Seguridad de la Información",
        body: [
          "Este sitio web utiliza una arquitectura Jamstack / estática, sin lógica de servidor expuesta ni bases de datos accesibles públicamente, lo que elimina vectores comunes de inyección, hackeo o fuga de datos propios de aplicaciones dinámicas tradicionales.",
          "Toda comunicación entre el Usuario y el portal oficial de distribución viaja cifrada mediante protocolos SSL/TLS de extremo a extremo. Los archivos de audio y portadas cargados por los Usuarios se almacenan bajo protocolos de acceso restringido.",
        ],
      },
      {
        heading: "6. Enlaces a Terceros / Portal Oficial",
        body: [
          "Los botones de \"Iniciar sesión\" y el formulario de registro de este sitio redirigen de forma segura al portal oficial distro.doblerrecords.com, donde el Usuario completará su autenticación y gestión de cuenta. Doble R Records no es responsable de las prácticas de privacidad de sitios de terceros a los que el Usuario pueda acceder desde enlaces externos.",
        ],
      },
      {
        heading: "7. No Venta de Datos a Terceros",
        body: [
          "Doble R Records no vende, alquila ni comercializa los datos personales de sus Usuarios con terceros para fines publicitarios o comerciales ajenos a la operación del servicio de distribución.",
        ],
      },
      {
        heading: "8. Derechos del Usuario",
        body: [
          "El Usuario podrá solicitar en cualquier momento el acceso, rectificación, actualización o eliminación de sus datos personales, escribiendo al correo de contacto indicado al final de esta política.",
        ],
      },
      {
        heading: "9. Retención de Datos",
        body: [
          "Los datos personales se conservarán durante el tiempo necesario para cumplir con la finalidad para la que fueron recabados y con las obligaciones legales, contables y administrativas aplicables al servicio de distribución musical.",
        ],
      },
      {
        heading: "10. Cambios a esta Política",
        body: [
          "Doble R Records podrá actualizar esta Política de Privacidad periódicamente. Cualquier cambio relevante será comunicado a través del portal oficial.",
        ],
      },
      {
        heading: "11. Contacto",
        body: [`Para ejercer sus derechos o realizar consultas sobre esta Política de Privacidad, escriba a ${CONTACT_EMAIL}.`],
      },
    ],
  },
  copyright: {
    title: "Política de Copyright y DMCA",
    updated: LAST_UPDATE,
    intro:
      "Doble R Records Distribution respeta los derechos de propiedad intelectual de terceros y exige a todos sus Usuarios el mismo estándar de respeto. Esta política describe las garantías exigidas a los Usuarios, así como el procedimiento de notificación y atención de reclamaciones por presunta infracción de derechos de autor, en línea con los principios de la Digital Millennium Copyright Act (DMCA) y la legislación de propiedad intelectual aplicable.",
    sections: [
      {
        heading: "1. Garantía de Titularidad",
        body: [
          "Al cargar cualquier lanzamiento a la plataforma, el Usuario garantiza y declara bajo su exclusiva responsabilidad que es el propietario legal de los derechos, o que posee las licencias exclusivas necesarias, sobre la totalidad del contenido entregado, incluyendo grabaciones (masters), pistas instrumentales (beats), samples, letras, composiciones e interpretaciones vocales o musicales.",
          "En caso de contenido colaborativo (featurings, remixes, samples licenciados), el Usuario declara contar con la autorización expresa y por escrito de todas las partes involucradas para su distribución digital comercial.",
        ],
      },
      {
        heading: "2. Contenido Prohibido",
        body: [
          "Queda estrictamente prohibida la carga de contenido que infrinja derechos de autor de terceros, incluyendo samples no autorizados, versiones no licenciadas de obras protegidas, o cualquier material obtenido sin la debida autorización de su titular.",
        ],
      },
      {
        heading: "3. Procedimiento de Notificación de Infracción (Takedown)",
        body: [
          `Cualquier tercero que considere que un contenido distribuido a través de nuestra plataforma infringe sus derechos de autor podrá presentar una notificación formal escribiendo a ${CONTACT_EMAIL}, incluyendo: (i) identificación de la obra protegida presuntamente infringida; (ii) identificación del contenido reclamado y su ubicación; (iii) datos de contacto del reclamante; (iv) declaración de buena fe sobre la falta de autorización; y (v) firma física o electrónica del titular o su representante autorizado.`,
          "Una vez recibida una notificación válida, Doble R Records procederá a evaluar la reclamación y, de ser procedente, retirará o inhabilitará el acceso al contenido reportado en un plazo razonable.",
        ],
      },
      {
        heading: "4. Contranotificación",
        body: [
          "El Usuario cuyo contenido haya sido retirado por una notificación de infracción podrá presentar una contranotificación fundamentada, exponiendo las razones por las cuales considera que el retiro fue improcedente, adjuntando evidencia de titularidad o licencia correspondiente.",
        ],
      },
      {
        heading: "5. Política de Reincidencia y Terminación de Cuenta",
        body: [
          "Doble R Records mantiene una política de tolerancia cero frente a infractores reincidentes. Los Usuarios que sean objeto de múltiples notificaciones válidas de infracción de derechos de autor serán sujetos a la terminación inmediata y definitiva de su cuenta, sin derecho a reembolso de comisiones ya generadas.",
        ],
      },
      {
        heading: "6. Congelamiento de Fondos en Disputa",
        body: [
          "En caso de disputas legales activas relacionadas con la titularidad de un lanzamiento, Doble R Records se reserva el derecho de congelar cautelarmente los fondos y regalías generados por dicho contenido hasta la resolución definitiva del conflicto entre las partes involucradas.",
        ],
      },
      {
        heading: "7. Indemnización",
        body: [
          "El Usuario se obliga a indemnizar y mantener indemne a Doble R Records frente a cualquier reclamación, daño, pérdida o gasto derivado del incumplimiento de las garantías de titularidad establecidas en esta política.",
        ],
      },
      {
        heading: "8. Contacto para Reclamaciones DMCA",
        body: [`Toda notificación de infracción de derechos de autor deberá dirigirse a ${CONTACT_EMAIL}.`],
      },
    ],
  },
  "streaming-artificial": {
    title: "Política de Streaming Artificial y Anti-Fraude",
    updated: LAST_UPDATE,
    intro:
      "La integridad de los datos de consumo es fundamental para el ecosistema de streaming musical. Doble R Records Distribution mantiene una política estricta de cero tolerancia frente a cualquier forma de streaming artificial o manipulación fraudulenta de reproducciones, en cumplimiento con las políticas anti-fraude de las plataformas digitales socias (DSPs).",
    sections: [
      {
        heading: "1. Definición de Streaming Artificial",
        body: [
          "Se considera streaming artificial toda reproducción, interacción o métrica generada de forma no orgánica, incluyendo pero no limitándose a: el uso de bots o software automatizado, granjas de clics (click farms), compra de reproducciones o seguidores fraudulentos, manipulación de listas de reproducción (playlists), y cualquier otra técnica destinada a inflar artificialmente las métricas de consumo de un lanzamiento.",
        ],
      },
      {
        heading: "2. Conductas Prohibidas",
        body: [
          "Queda estrictamente prohibido para todos los Usuarios de la plataforma: contratar servicios de terceros que ofrezcan reproducciones garantizadas; utilizar redes de bots o granjas de dispositivos; participar en esquemas de intercambio de reproducciones (\"stream farms\" o \"playlist swapping\"); y cualquier automatización de escucha no realizada por un oyente humano real.",
        ],
      },
      {
        heading: "3. Detección y Monitoreo",
        body: [
          "Doble R Records, en conjunto con las plataformas digitales asociadas, realiza monitoreo continuo y auditorías internas sobre los patrones de consumo de los lanzamientos distribuidos, utilizando herramientas de detección de anomalías proporcionadas por las propias DSPs.",
        ],
      },
      {
        heading: "4. Traspaso de Penalizaciones de las DSPs",
        body: [
          "En caso de que una plataforma digital (Spotify, Apple Music, Amazon Music u otra) determine la existencia de streaming artificial asociado a un lanzamiento y aplique multas, retenciones o sanciones administrativas, dichas penalizaciones serán trasladadas de forma directa e íntegra al Usuario responsable del contenido, quien asumirá su costo en su totalidad.",
        ],
      },
      {
        heading: "5. Retención de Regalías y Congelamiento de Pagos",
        body: [
          "Doble R Records se reserva el derecho de congelar el pago de regalías generadas por un lanzamiento mientras se investiga una posible actividad fraudulenta, hasta que la situación sea aclarada por la plataforma digital correspondiente.",
        ],
      },
      {
        heading: "6. Auditoría Interna",
        body: [
          "La Distribuidora podrá realizar auditorías internas periódicas sobre cualquier cuenta o catálogo que presente patrones de consumo inusuales, solicitando al Usuario información adicional que permita esclarecer el origen del tráfico reportado.",
        ],
      },
      {
        heading: "7. Eliminación de Catálogo",
        body: [
          "En caso de confirmarse actividad fraudulenta, Doble R Records se reserva el derecho de eliminar de forma inmediata y permanente el catálogo completo del Usuario infractor de todas las plataformas digitales, sin derecho a reclamación por las regalías retenidas o no percibidas.",
        ],
      },
      {
        heading: "8. Consecuencias Contractuales",
        body: [
          "La comprobación de streaming artificial constituirá causal de terminación inmediata del contrato de distribución, sin perjuicio de las acciones legales y administrativas que Doble R Records pueda ejercer para el resarcimiento de los daños ocasionados por las penalizaciones de las DSPs.",
        ],
      },
      {
        heading: "9. Contacto",
        body: [`Para consultas relacionadas con esta política, escriba a ${CONTACT_EMAIL}.`],
      },
    ],
  },
};

export const LEGAL_SLUGS = ["terminos", "privacidad", "copyright", "streaming-artificial"];
